var $576be2ddc0818dc4$exports = {};
$576be2ddc0818dc4$exports = {
  "collapse": "Ahenda",
  "expand": "Laienda"
};
export { $576be2ddc0818dc4$exports as default };